import { createSlice } from "@reduxjs/toolkit";

export const eocActiveSlice = createSlice({
    name: 'eocActive',
    initialState: {
        value: undefined
    },
    reducers: {
        setEOCActive: (state, action) => {
            state.value = action.payload;
        }
    }
})

export const { setEOCActive } = eocActiveSlice.actions;

export const getEOCActive = (state) => state.eocActive.value;

export default eocActiveSlice.reducer;